/**
 * Модуль производящий прокрутку до указанного элемента
 *
 */

( function () {
    'use strict';

    window.scrollToElement = scrollToElement;
    /**
     * Производит прокрутку страницы до указанного элемента
     *
     * @param {Object} element Ссылка на элемент
     */
    function scrollToElement(element) {
        if (!element) {
            return;
        }

        var position = element.getBoundingClientRect();

        setTimeout(function () {
            scrollTo(element, position.top, 300);
        }, 100);
    }

    /**
     * Возвращает значени top указанного элмента оносительно окна браузера
     *
     * @param {Object} element Ссылка на элемент
     *
     * @returns {Number}
     */
    function getElementTop(element) {
        return element.getBoundingClientRect().top + window.pageYOffset;
    }

    /**
     * Производит прокрутку страниы до указанного элемента
     *
     * @param {Object} element Ссылка на элемент
     * @param {Number} to Координата Y
     * @param {Number} duration Длительность
     *
     */
    function scrollTo(element, to, duration) {
        if (duration <= 0) {
            window.scrollTo(0, getElementTop(element) - 2);
            return;
        }
        var difference = to - window.pageYOffset;
        var perTick = difference / duration * 10;

        setTimeout(function () {
            window.scrollBy(0, Math.abs(perTick));

            if (window.pageYOffset >= to) {
                window.scrollTo(0, getElementTop(element) - 2);
                return;
            }

            scrollTo(element, to, duration - 10);
        }, 10);
    }

}());

